import React, { useEffect, useState } from 'react';
import { getAuthStatus } from '../../localstorage';
import { useNavigate } from 'react-router-dom';

export default function Calculator() {
    const [result, setResult] = useState('');
    const [expression, setExpression] = useState('');

    const [authenticated, setAuthenticated] = useState(false);
    const navigate = useNavigate(); // Move useNavigate here

  useEffect(() => {
    const checkAuthentication = () => {
      const isAuthenticated = getAuthStatus('_id');
      if (!isAuthenticated) {
        navigate("/login");
      } else {
        setAuthenticated(true);
      }
    };

    checkAuthentication();
  }, [navigate]);


    const handleKeyPress = event => {
        if (event.key === 'Enter') {
            calculateResult();
        }
    };

    const calculateResult = () => {
        try {
            const res = eval(expression);
            setResult(res);
        } catch (error) {
            setResult('Error');
        }
    };

    return (
        <div>
            <h1>Simple Calculator</h1>
            <div>
                <input
                    type="text"
                    value={expression}
                    onChange={e => setExpression(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                <button onClick={calculateResult}>Calculate</button>
            </div>
            <div>
                <h2>Result: {result}</h2>
            </div>
            <div>
                <h2>Code Snippet: (JSX)</h2>
                <pre>{`
                import React, { useState } from 'react';

                export default function Calculator() {
                   const [result, setResult] = useState('');
                   const [expression, setExpression] = useState('');
               
                   const handleKeyPress = event => {
                       if (event.key === 'Enter') {
                           calculateResult();
                       }
                   };
               
                   const calculateResult = () => {
                       try {
                           const res = eval(expression);
                           setResult(res);
                       } catch (error) {
                           setResult('Error');
                       }
                   };
               
                   return (
                    <div>
                    <h1>Simple Calculator</h1>
                    <div>
                        <input
                            type="text"
                            value={expression}
                            onChange={e => setExpression(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <button onClick={calculateResult}>Calculate</button>
                    </div>
                    <div>
                        <h2>Result: {result}</h2>
                    </div>
                    <div>
                   );
                }
                `}</pre>
            </div>
        </div>
    );
}
